<template>
  <div class="ath clearfix">
    <div class="left">
      <img
        :src="flag ? authUrl : unauthUrl"
        :alt="flag ? '已授权' : '未授权'"
      />
      <span :style="{ color: flag ? '#22BC02' : '#FD5801' }">{{
        flag
          ? dataStr[num].open.split("，")[0]
          : dataStr[num].close.split("，")[0]
      }}</span>
      <span>{{
        flag
          ? dataStr[num].open.split("，")[1]
          : dataStr[num].close.split("，")[1]
      }}</span>
      <!-- <div class="rule" v-if="flag">
        <span>查看</span
        ><span class="rule-info" @click="followUpRule">跟进规则</span>
      </div> -->
    </div>
    <div class="right" @click="gosq" v-if="checkAuth('authConfig')">
      <span>去设置 ></span>
    </div>
  </div>
</template>
<script>
import {common} from "@/api/mixins";
export default {
  mixins: [common],
  props: {
    num: Number,
  },
  data() {
    return {
      authUrl: require("@/static/images/order/orderD7.png"),
      unauthUrl: require("@static/images/order/orderD6.png"),
      mechanInfo: {},
      dataStr: [
        {
          open: "已授权凤栖云服跟进，凤栖云服顾问将以您的名义进行转化",
          close:
            "未授权凤栖云服跟进，凤栖云服顾问将不再直接联系客户，请留意客户预约信息并进行跟进",
        }, //预约订单
        {
          open:
            "已授权凤栖云服跟进，凤栖云服顾问将以您的名义跟进客户保单续费情况",
          close:
            "未授权凤栖云服跟进，凤栖云服顾问将不再直接联系客户，请留意客户保单续费情况",
        }, //续费管理
        {
          open: "已授权凤栖云服跟进，凤栖云服顾问将以您的名义进行转化",
          close:
            "未授权凤栖云服跟进，凤栖云服顾问将不再直接联系客户，请留意客户定制方案订单并进行跟进",
        }, //定制方案订单
        {
          open:
            "已授权凤栖云服跟进，凤栖云服顾问将以您的名义跟进客户保单续保情况",
          close:
            "未授权凤栖云服跟进，凤栖云服不再提醒客户续保，请您自行跟进客户续保情况",
        }, //续保管理
      ],
      flag: false,
    };
  },
  created() {
    this.queryMechanConfig();
    this.mechanInfo = this.$tools.getLocal("userinfo");
  },
  mounted() {},
  methods: {
    queryMechanConfig: function () {
      var that = this;
      this.$http({
        url: "/master/mechan/queryMechanConfig",
        type: "put",
        params: {},
      }).then(function (data) {
        if (that.num == 0) {
          data.data.isFollow == 0 ? (that.flag = false) : (that.flag = true);
        } else if (that.num == 1) {
          data.data.isRenewalAuthorized == 0
            ? (that.flag = false)
            : (that.flag = true);
        } else if (that.num == 2) {
          data.data.paymentPlanAuthorized == false
            ? (that.flag = false)
            : (that.flag = true);
        }
      });
    },
    gosq: function () {
      this.$router.push({
        path: "/setting/auth",
        query:{source:'1'} // source为1 ，授权设置页面有返回键，否则没有
      });
    },
    followUpRule() {
      this.$notice.msg("暂无", 2, 1500);
    },
  },
};
</script>
<style lang="scss">
.ath {
  line-height: 40px;
  padding: 10px 20px;
  font-size: 14px;
  background: #f7f7f7;
  margin-bottom: 10px;
  .left {
    float: left;
    img {
      margin-right: 8px;
      height: 34px;
      width: 34px;
    }
    span {
      font-size: 14px;
      font-family: PingFangSC-Regular;
      vertical-align: middle;
      color: #888888;
      margin-right: 20px;
    }
    .rule {
      display: inline-block;
      margin-left: 45px;

      .rule-info {
        color: #ff9700;
        font-weight: 500;
      }
    }
  }
  .right {
    float: left;
    color: #ff9700;
    cursor: pointer;
    margin-left: 65px;
    span {
      vertical-align: middle;
    }
  }
}
</style>
